import React, { useState, useEffect } from 'react';
import { useAuth } from '../auth/AuthContext';
import { apiFetch } from '../api';
import { PageHeader, HistoryTimeline } from './ui';
function HistoryPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    setLoading(true);
    apiFetch('/api/history/?page_size=100&ordering=-created_at')
      .then((data) => {
        setItems(data.results || data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setError('Не удалось загрузить историю');
        setLoading(false);
      });
  }, []);

useEffect(() => {
  document.title = 'История изменений — Производство';
}, []);

  if (loading) return <div className="empty-state">Загрузка...</div>;
  if (error) return <div className="empty-state text-danger">{error}</div>;

  return (
    <>
      <PageHeader
        title="История изменений"
        subtitle="Все действия пользователей в системе"
      />
      <div className="app-card">
        <div className="app-card-body">
          <HistoryTimeline items={items} />
        </div>
      </div>
    </>
  );
}

export default HistoryPage;